export * from './category-list-component-config';
